'use client';

import clsx from 'clsx';
import Image from 'next/image';
import { useLayoutEffect, useRef } from 'react';

import ScrollAnimatedText, { ScrollAnimatedTextLine } from '@/components/ScrollAnimatedText';
import useDevice from '@/hooks/useDevice';
import { gsap } from '@/lib/gsap';

import css from './style.module.scss';

const textLines: ScrollAnimatedTextLine[] = [
	{ text: 'Founded in Kyiv 7 years ago,' },
	{ text: 'we deliver crème de la crème' },
	{ text: 'quality and always go' },
	{ text: 'beyond the brief. Every' },
	{ text: 'brand is our chance to level' },
	{ text: 'up its game.' }
];

const GoalText = () => {
	const device = useDevice();
	const wrapperRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		const wrapper = wrapperRef.current;
		const circle = wrapper?.querySelector(`.${css.curvedText}`);

		if (!wrapper || !circle) return;

		const ctx = gsap.context(() => {
			gsap.timeline({
				scrollTrigger: {
					trigger: wrapper,
					start: 'top bottom',
					end: 'bottom+=100% top',
					scrub: true,
					onUpdate: ({ progress }) => {
						const scrollProgress = progress * 360;
						gsap.to(circle, {
							rotate: scrollProgress,
							ease: 'none',
							duration: 0
						});
					}
				}
			});
		}, wrapper);

		return () => {
			ctx.revert();
		};
	}, []);

	return (
		<section ref={wrapperRef} className={clsx('wrapper', css.wrapper)}>
			<div className={css.curvedWrapper}>
				<div className={css.curvedContainer}>
					<div className={css.circle} />

					<ScrollAnimatedText lines={textLines} className={css.animatedText} />
				</div>

				<div className={css.curvedContainer}>
					<Image
						preload
						width={device === 'desktop' ? 1775 : 424}
						height={device === 'desktop' ? 1775 : 424}
						alt=""
						className={css.curvedText}
						src={
							device === 'desktop'
								? '/assets/images/circle-text-white.webp'
								: '/assets/images/circle-text-mobile.webp'
						}
					/>
				</div>
			</div>
		</section>
	);
};

export default GoalText;
